/**
 * scoreTrackDrag.js
 * Permet de déplacer librement la piste de score (scoreTrackFloating)
 * Compatible mobile et desktop
 */

(function() {
  'use strict';

  // Fonction pour initialiser le drag sur la piste de score
  function initScoreTrackDrag() {
    const scoreTrack = document.getElementById('scoreTrackFloating');
    if (!scoreTrack) {
      console.warn('scoreTrackFloating not found');
      return;
    }

    // Inline mode (embedded above the hand dock) should not be draggable.
    // This avoids saved drag positions pushing it off-screen on desktop/mobile.
    if (scoreTrack.getAttribute('data-inline') === '1') {
      // 🔧 CORRECTION: Nettoyer complètement le style et localStorage en mode inline
      try { 
        localStorage.removeItem('scoreTrackPosition');
        scoreTrack.style.position = '';
        scoreTrack.style.left = '';
        scoreTrack.style.top = '';
        scoreTrack.style.bottom = '';
        scoreTrack.style.transform = '';
        scoreTrack.classList.remove('dragging');
      } catch (_e) {}
      return;
    }

    let isDragging = false;
    let currentX = 0;
    let currentY = 0;
    let initialX = 0;
    let initialY = 0;
    let offsetX = 0;
    let offsetY = 0;

    // Charger la position sauvegardée
    const savedPosition = localStorage.getItem('scoreTrackPosition');
    if (savedPosition) {
      try {
        const pos = JSON.parse(savedPosition);
        scoreTrack.style.left = pos.x;
        scoreTrack.style.top = pos.y;
        scoreTrack.style.bottom = 'auto';
        scoreTrack.style.transform = 'none';
      } catch (e) {
        console.error('Error loading saved position:', e);
        localStorage.removeItem('scoreTrackPosition');
      }
    }

    // Fonction pour sauvegarder la position
    function savePosition() {
      const position = {
        x: scoreTrack.style.left,
        y: scoreTrack.style.top
      };
      localStorage.setItem('scoreTrackPosition', JSON.stringify(position));
    }

    // Desktop: mousedown
    scoreTrack.addEventListener('mousedown', dragStart);
    
    // Mobile: touchstart
    scoreTrack.addEventListener('touchstart', dragStart, { passive: false });

    function dragStart(e) {
      if (e.type === 'touchstart') {
        initialX = e.touches[0].clientX - offsetX;
        initialY = e.touches[0].clientY - offsetY;
      } else {
        initialX = e.clientX - offsetX;
        initialY = e.clientY - offsetY;
      }

      if (e.target === scoreTrack || scoreTrack.contains(e.target)) {
        isDragging = true;
        scoreTrack.classList.add('dragging');
        
        // Désactiver le positionnement automatique
        scoreTrack.style.bottom = 'auto';
        scoreTrack.style.transform = 'none';
        
        document.addEventListener('mousemove', drag);
        document.addEventListener('mouseup', dragEnd);
        document.addEventListener('touchmove', drag, { passive: false });
        document.addEventListener('touchend', dragEnd);
      }
    }

    function drag(e) {
      if (isDragging) {
        e.preventDefault();
        
        if (e.type === 'touchmove') {
          currentX = e.touches[0].clientX - initialX;
          currentY = e.touches[0].clientY - initialY;
        } else {
          currentX = e.clientX - initialX;
          currentY = e.clientY - initialY;
        }

        offsetX = currentX;
        offsetY = currentY;

        // Limiter dans les bounds de la fenêtre
        const rect = scoreTrack.getBoundingClientRect();
        const maxX = window.innerWidth - rect.width;
        const maxY = window.innerHeight - rect.height;
        
        const boundedX = Math.max(0, Math.min(currentX, maxX));
        const boundedY = Math.max(0, Math.min(currentY, maxY));

        scoreTrack.style.left = boundedX + 'px';
        scoreTrack.style.top = boundedY + 'px';
      }
    }

    function dragEnd() {
      if (isDragging) {
        isDragging = false;
        scoreTrack.classList.remove('dragging');
        
        document.removeEventListener('mousemove', drag);
        document.removeEventListener('mouseup', dragEnd);
        document.removeEventListener('touchmove', drag);
        document.removeEventListener('touchend', dragEnd);

        // Sauvegarder la position
        savePosition();
      }
    }

    // Bouton de réinitialisation (double-clic pour réinitialiser la position)
    scoreTrack.addEventListener('dblclick', function() {
      scoreTrack.style.left = '50%';
      scoreTrack.style.top = '80px';  // Position en dessous de la topBar
      scoreTrack.style.bottom = 'auto';
      scoreTrack.style.transform = 'translateX(-50%)';
      offsetX = 0;
      offsetY = 0;
      localStorage.removeItem('scoreTrackPosition');
      
      // Toast feedback
      const toast = document.getElementById('toast');
      if (toast) {
        toast.textContent = '🎯 Position réinitialisée';
        toast.classList.add('show');
        setTimeout(() => toast.classList.remove('show'), 2000);
      }
    });

    // Réajuster sur redimensionnement
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        // Vérifier si la piste est toujours dans les limites
        const rect = scoreTrack.getBoundingClientRect();
        if (rect.left < 0 || rect.right > window.innerWidth || 
            rect.top < 0 || rect.bottom > window.innerHeight) {
          // Repositionner au centre
          scoreTrack.style.left = '50%';
          scoreTrack.style.top = '80px';
          scoreTrack.style.transform = 'translateX(-50%)';
          offsetX = 0;
          offsetY = 0;
          savePosition();
        }
      }, 250);
    });
  }

  // Initialiser quand le DOM est prêt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScoreTrackDrag);
  } else {
    initScoreTrackDrag();
  }

})();
